import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getBackOfficeAgentBranchFees = (paginate, personId) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/agent_branch_fee`
    );
  }
  return http.get(
    `${getBaseUrl()}/back_office_agent_branch_fee?${paginate}`
  );
};
